import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyBf8D_1lJglgZKoISljm6PzJS3j3i3lWGc",
  authDomain: "codenames-46a0a.firebaseapp.com",
  databaseURL: "https",
  projectId: "codenames-46a0a",
  storageBucket: "codenames-46a0a.appspot.com",
  messagingSenderId: "1:1024204413871:web:3d84511639122b38c66d5a"
}

firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()

export { db }
